<template>
  <base-button
    icon="el-icon-refresh"
    :loading="loading"
    @click="$emit('click')">
    {{ label || $t('settings.refresh') }}
  </base-button>
</template>

<script>
import BaseButton from '@/components/common/BaseButton';

export default {
  name: 'BaseRefreshButton',
  components: {BaseButton},
  props: {
    loading: {type: Boolean, default: false},
    label: {type: String, default: null}
  }
};
</script>
